import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CursorClick } from "@phosphor-icons/react";

function ClickTable({ title, rows, testid, label }) {
  return (
    <div data-testid={testid} className="min-w-0 border border-[#E5E0D8] bg-white rounded-2xl p-6">
      <h3 className="font-display text-xl text-[#2C2B29] mb-4">{title}</h3>
      {rows.length === 0 ? (
        <p className="text-sm text-[#5C5A56]">No clicks yet.</p>
      ) : (
        <ol className="space-y-2.5">
          {rows.map((r, i) => (
            <li key={label(r)} className="flex items-center gap-3 text-sm">
              <span className="w-6 text-[#5C5A56]">{i + 1}.</span>
              <span className="flex-1 truncate text-[#2C2B29]">{label(r)}</span>
              <span className="font-semibold text-[#D17A58]">{r.clicks}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}

export function ClicksPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/clicks/summary").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <section className="mb-10">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-2xl text-[#2C2B29] flex items-center gap-2">
          <CursorClick size={22} weight="duotone" className="text-[#D17A58]" /> "Buy Now" clicks
        </h2>
        <span data-testid="clicks-total" className="text-sm text-[#5C5A56]">All-time total: <b className="text-[#2C2B29]">{data.total}</b></span>
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        <ClickTable title="Top products" rows={data.top_products} testid="clicks-top-products" label={(r) => r.title} />
        <ClickTable title="Top pages & articles" rows={data.top_pages} testid="clicks-top-pages" label={(r) => r.label} />
      </div>
    </section>
  );
}
